<template #content>
    <Dialog :visible="visible" @update:visible="updateVisible" :header="'Perfil: ' + perfil.descricao" @show="onShow"
        @hide="onHide" class="w-11 lg:w-8" modal>
        <form @submit.prevent="onSubmit">
            <!-- administrador não é permissão: fica fora das abas e do "Selecionar todos" -->
            <div v-if="mostrarAdministrador" class="perm-admin mb-3">
                <div class="flex align-items-center gap-2">
                    <Checkbox inputId="perm-administrador" v-model="administrador" binary
                        :disabled="isLoading || administradorTravado"
                        aria-describedby="perm-administrador-ajuda" />
                    <label for="perm-administrador" class="perm-admin__label">Administrador</label>
                </div>
                <small id="perm-administrador-ajuda" class="perm-admin__ajuda">
                    {{ administradorTravado
                        ? 'Você não tem permissão para remover administrador. Procure o suporte.'
                        : 'Administrador tem acesso total ao sistema, independente das permissões marcadas.' }}
                </small>
                <small v-if="erroAdministrador" class="perm-admin__erro" role="alert">{{ erroAdministrador }}</small>
            </div>

            <Tabs class="contrato-tab-principal" :value="tabIndex">
                <TabList>
                    <Tab v-for="aba in abas" :key="aba.value" :value="aba.value">{{ aba.titulo }}</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel v-for="aba in abas" :key="aba.value" :value="aba.value">
                        <div class="flex align-items-center justify-content-between gap-2 mb-3">
                            <span class="font-semibold text-color">{{ aba.titulo }}</span>
                            <Button type="button" size="small" outlined
                                :icon="aba.todasMarcadas ? 'pi pi-times-circle' : 'pi pi-check-circle'"
                                :label="aba.todasMarcadas ? 'Limpar seleção' : 'Selecionar todos'"
                                :disabled="isLoading || !aba.cards.length"
                                @click="marcarTudo(aba, !aba.todasMarcadas)" />
                        </div>

                        <p v-if="isLoading" class="perm-aviso">Carregando…</p>
                        <div v-else class="perm-grid">
                            <section v-for="card in aba.cards" :key="card.key" class="perm-card"
                                :class="{ 'perm-card--full': card.full }">
                                <header class="perm-card__head">
                                    <Checkbox v-if="card.no" binary
                                        :modelValue="estadoDe(card.no, aba.mapa).checked"
                                        :indeterminate="estadoDe(card.no, aba.mapa).parcial"
                                        :ariaLabel="'Marcar tudo em ' + card.label"
                                        @update:modelValue="marcarNo(card.no, aba.mapa, $event)" />
                                    <h4 class="perm-card__titulo">{{ card.label }}</h4>
                                </header>

                                <div v-for="secao in card.secoes" :key="secao.key"
                                    :class="{ 'perm-secao': secao.label }">
                                    <header v-if="secao.label" class="perm-secao__head">
                                        <Checkbox binary
                                            :modelValue="estadoDe(secao.no, aba.mapa).checked"
                                            :indeterminate="estadoDe(secao.no, aba.mapa).parcial"
                                            :ariaLabel="'Marcar tudo em ' + secao.label"
                                            @update:modelValue="marcarNo(secao.no, aba.mapa, $event)" />
                                        <h5 class="perm-secao__titulo">{{ secao.label }}</h5>
                                    </header>
                                    <ul class="perm-lista" :class="{ 'perm-lista--colunas': card.full }">
                                        <li v-for="item in secao.itens" :key="item.key" class="perm-item">
                                            <Checkbox binary v-model="aba.mapa[item.key]"
                                                :disabled="item.id === ID_REMOVER_ADMINISTRADOR && !podeAdministrar"
                                                :inputId="aba.value + '-' + item.key" />
                                            <label :for="aba.value + '-' + item.key" class="perm-item__label">
                                                {{ item.label }}
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                            </section>
                        </div>
                    </TabPanel>
                </TabPanels>
            </Tabs>

            <div class="flex justify-content-end gap-1">
                <Button type="submit" label="Salvar" severity="success" icon="pi pi-save" size="small"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
                <Button label="Fechar" severity="warn" icon="pi pi-times" size="small" @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
            </div>
        </form>

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import Checkbox from 'primevue/checkbox';
import Button from 'primevue/button';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import Perfil from '@/service/perfil.js';

export default {
    components: { Dialog,
                  Button,
                  Checkbox,
                  Tabs,
                  TabList,
                  Tab,
                  TabPanels,
                  TabPanel, },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        perfil: {
            type: Object,
            default: {}
        },
        podeAdministrar: {
            type: Boolean,
            default: false
        },
        podeRemoverAdministrador: {
            type: Boolean,
            default: false
        },
    },
    emits: ['save', 'close'],
    data() {
        return {
            // só administrador concede/retira (o backend ignora a linha dos demais): não deixa marcar à toa
            ID_REMOVER_ADMINISTRADOR: 101,
            // árvore crua da API; o estado dos agrupadores é sempre derivado das folhas
            permissaoNos: [],
            permissaoChecked: {},
            etapaNos: [],
            etapaChecked: {},
            isLoading: false,
            tabIndex: 0,
            administrador: false,
            administradorInicial: false,
            erroAdministrador: '',
        }
    },
    computed: {
        // perfil já administrador só desmarca quem tem USUARIO_REMOVER_ADMINISTRADOR (o backend decide o resto: 403/422)
        administradorTravado() {
            return !!this.perfil.administrador && !this.podeRemoverAdministrador;
        },
        // quem só tem a permissão de remover vê o checkbox apenas em perfil já administrador (nada a marcar nos outros)
        mostrarAdministrador() {
            return this.podeAdministrar || (this.podeRemoverAdministrador && !!this.perfil.administrador);
        },

        abas() {
            return [
                { value: 0, titulo: 'Permissões', nos: this.permissaoNos, mapa: this.permissaoChecked, cards: this.permissaoCards },
                { value: 1, titulo: 'Etapas',     nos: this.etapaNos,     mapa: this.etapaChecked,     cards: this.etapaCards },
            ].map(aba => {
                const folhas = this.folhas(aba.nos);
                return { ...aba, todasMarcadas: folhas.length > 0 && folhas.every(folha => aba.mapa[folha.key]) };
            });
        },

        permissaoCards() {
            const cards = [];
            const soltas = [];

            this.permissaoNos.forEach(no => {
                if (!this.temFilhos(no)) return soltas.push(no);

                const secoes = [{ key: no.key, label: null, no: null, itens: no.children.filter(f => !this.temFilhos(f)) }];
                no.children.filter(f => this.temFilhos(f))
                    .forEach(sub => secoes.push({ key: sub.key, label: sub.label, no: sub, itens: this.folhas([sub]) }));

                cards.push({ key: no.key, label: no.label, no, secoes });
            });

            // raízes sem grupo não têm card natural: viram um card "Geral" no fim
            if (soltas.length) {
                cards.push({ key: 'geral', label: 'Geral', no: null, secoes: [{ key: 'geral', label: null, no: null, itens: soltas }] });
            }
            return cards;
        },

        etapaCards() {
            if (!this.etapaNos.length) return [];
            return [{ key: 'etapas', label: 'Etapas do contrato', no: null, full: true,
                      secoes: [{ key: 'etapas', label: null, no: null, itens: this.etapaNos }] }];
        },
    },
    methods: {
        temFilhos(no) {
            return Array.isArray(no.children) && no.children.length > 0;
        },

        folhas(nos) {
            return nos.flatMap(no => this.temFilhos(no) ? this.folhas(no.children) : [no]);
        },

        // estado do agrupador nunca é guardado: sai dos filhos, como o Tree fazia
        estadoDe(no, mapa) {
            if (!this.temFilhos(no)) return { checked: !!mapa[no.key], parcial: false };

            const filhos = no.children.map(filho => this.estadoDe(filho, mapa));
            const todos = filhos.every(e => e.checked);

            return { checked: todos, parcial: !todos && filhos.some(e => e.checked || e.parcial) };
        },

        marcarNo(no, mapa, valor) {
            this.folhas([no]).forEach(folha => { mapa[folha.key] = valor; });
        },

        marcarTudo(aba, valor) {
            this.folhas(aba.nos).forEach(folha => { aba.mapa[folha.key] = valor; });
        },

        // API manda checked como string JSON; só as folhas entram no mapa
        carregarChecked(nos, mapa) {
            nos.forEach(no => {
                if (this.temFilhos(no)) return this.carregarChecked(no.children, mapa);

                const checked = typeof no.checked === 'string' ? JSON.parse(no.checked) : no.checked;
                mapa[no.key] = !!(checked && checked.checked);
            });
            return mapa;
        },

        onShow() {
            this.administrador        = !!this.perfil.administrador;
            this.administradorInicial = this.administrador;
            this.erroAdministrador    = '';
            this.isLoading = true;

            Promise.all([
                Perfil.permissoes(this.perfil.id),
                Perfil.etapas(this.perfil.id),
            ]).then(([permissoesRes, etapasRes]) => {
                this.permissaoNos     = permissoesRes.data;
                this.permissaoChecked = this.carregarChecked(this.permissaoNos, {});

                this.etapaNos     = etapasRes.data;
                this.etapaChecked = this.carregarChecked(this.etapaNos, {});
            }).finally(() => {
                this.isLoading = false;
            });
        },

        onHide() {
            this.permissaoNos     = [];
            this.permissaoChecked = {};
            this.etapaNos         = [];
            this.etapaChecked     = {};
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },

        // desmarcado não vai no payload: o controller faz delete + insert
        getSelectedKeyData(nos, mapa, dados = []) {
            nos.forEach(no => {
                const estado = this.estadoDe(no, mapa);

                if (this.temFilhos(no)) this.getSelectedKeyData(no.children, mapa, dados);

                if (estado.checked) dados.push({ id: no.id, checked: 1 });
                else if (estado.parcial) dados.push({ id: no.id, checked: 2 });
            });
            return dados;
        },

        // administrador vai primeiro: se o servidor recusar (403 / último admin), nada é gravado e o diálogo fica aberto
        async onSubmit() {
            const dados = { permissoes: this.getSelectedKeyData(this.permissaoNos, this.permissaoChecked),
                            etapas: this.getSelectedKeyData(this.etapaNos, this.etapaChecked) };

            this.erroAdministrador = '';
            this.isLoading = true;
            try {
                // checkbox só aparece/habilita para quem pode mexer; aqui basta enviar se mudou
                if (this.administrador !== this.administradorInicial) {
                    await Perfil.update(this.perfil.id, { descricao: this.perfil.descricao, administrador: this.administrador });
                    this.administradorInicial = this.administrador;
                }
                await Perfil.configuracao(this.perfil.id, dados);

                this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });
                this.$emit('save');
                this.$emit('close');
            } catch (error) {
                const resposta = error.response?.data;
                const erroCampo = resposta?.erros?.administrador;
                if (erroCampo) {
                    this.erroAdministrador = Array.isArray(erroCampo) ? erroCampo[0] : erroCampo;
                    return;
                }
                this.$toast.add({ severity: 'error', summary: 'Ops!', detail: resposta?.msg || error.message, life: 5000 });
            } finally {
                this.isLoading = false;
            }
        }
    }
}
</script>
<style scoped>
.perm-grid {
    display: grid;
    /* auto-fill acompanha a largura real do diálogo: 3 colunas em tela larga, 2 em média, 1 em estreita */
    grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));
    align-content: start;
    gap: .75rem;
    max-height: 55vh;
    overflow-y: auto;
    padding-right: .25rem;
}

.perm-card {
    /* mistura com o texto: clareia o card no tema escuro e escurece no claro, sem cor fixa */
    background: color-mix(in srgb, var(--p-text-color) 4%, var(--p-content-background));
    border: 1px solid var(--p-content-border-color);
    border-radius: 8px;
    padding: .875rem;
}

.perm-card--full {
    grid-column: 1 / -1;
}

.perm-card__head,
.perm-secao__head {
    display: flex;
    align-items: center;
    gap: .5rem;
    margin-bottom: .625rem;
}

.perm-card__titulo {
    margin: 0;
    font-size: .75rem;
    font-weight: 700;
    letter-spacing: .04em;
    text-transform: uppercase;
    /* texto normal, não muted: com os itens em laranja, o título apagado parecia secundário */
    color: var(--p-text-color);
}

.perm-secao {
    margin-top: .875rem;
    padding-left: .75rem;
    border-left: 2px solid var(--p-content-border-color);
}

.perm-secao__head {
    margin-bottom: .5rem;
}

.perm-secao__titulo {
    margin: 0;
    font-size: .6875rem;
    font-weight: 600;
    letter-spacing: .03em;
    text-transform: uppercase;
    color: var(--p-text-muted-color);
}

.perm-lista {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: .5rem;
}

.perm-lista--colunas {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
}

.perm-item {
    display: flex;
    align-items: center;
    gap: .5rem;
}

.perm-item__label {
    font-size: .875rem;
    line-height: 1.2;
    color: var(--primary-color-texto);
    cursor: pointer;
}

.perm-admin {
    background: color-mix(in srgb, var(--primary-color) 8%, var(--p-content-background));
    border: 1px solid color-mix(in srgb, var(--primary-color) 45%, var(--p-content-border-color));
    border-radius: 8px;
    padding: .75rem .875rem;
}

.perm-admin__label {
    font-weight: 700;
    color: var(--p-text-color);
    cursor: pointer;
}

.perm-admin__ajuda,
.perm-admin__erro {
    display: block;
    margin-top: .375rem;
    font-size: .75rem;
}

.perm-admin__ajuda {
    color: var(--p-text-muted-color);
}

.perm-admin__erro {
    color: var(--p-red-500);
}

.perm-aviso {
    margin: 0;
    padding: 2rem 0;
    text-align: center;
    color: var(--p-text-muted-color);
}
</style>
